<template>
	<div id="registration">
		<div class="nav" v-if="navShow">
			<a :href="navhomeUrl" target="_top">首页</a>
			> <a>报名</a>
		</div>
		<Loading v-if="show"></Loading>
		<div class="registration-container" v-else>
			<div class="registration-container">
				<div id="num_popup" v-show="flags.isTiketModalShow">
					<ChooseTicketModal :datas="ticketModalsDatas" @submit="handleGetTicketDatas" />
				</div>
				<div class="registration_main" v-if="signUpData">
					<div class="registration-banner">
						<img :src="signUpData.signUp_Set.mobile_image || bannerSrc" alt />
					</div>
					<div class="registration-content">
						<h2 class="registrationContent-title">
							<div v-for="(item, index) in meetingTitle" :key="index">
								{{ item }}
							</div>
						</h2>
						<div class="signup_desc" v-if="ticketModalsDatas.type_desc"
							v-html="ticketModalsDatas.type_desc"></div>
						<div class="loading" v-if="loading">
							<van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...
							</van-loading>
						</div>
						<van-collapse v-model="activeNames">
							<van-collapse-item v-for="(items, indexs) in forms" :key="indexs" :name="indexs"
								id="sl-collapse-item" :disabled="forms.length == 1">
								<div slot="title" :class="{ disNone: forms.length == 1 }">
									第{{ indexs + 1 }}位
								</div>
								<form action class="registrationContent-form">
									<template v-for="(item, index) in items">
										<!-- 输入框 -->
										<div class="formItem" :key="index"
											v-if="item.formtype === 1 && item.formfix === 0">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<input type="text" name :placeholder="item.formdes" v-model="item.formval"
												:formfix="item.formfix" />
										</div>
										<!-- 姓名 -->
										<div class="formItem" :key="index"
											v-if="item.formtype === 1 && item.formfix === 2">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<input type="text" name :placeholder="item.formdes" v-model="item.formval"
												:formfix="item.formfix" @blur="publicSignup.on_blur()" />
										</div>
										<!-- 年龄 -->
										<div class="formItem" :key="index"
											v-if="item.formtype === 1 && item.formfix === 6">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<input type="text" name :placeholder="item.formdes" v-model="item.formval"
												:formfix="item.formfix" @change="reNumber(item.formval, $event)"
												@blur="publicSignup.on_blur()" />
										</div>
										<!-- 手机号 -->
										<div class="formItem" :key="index"
											v-if="item.formtype === 1 && item.formfix === 1">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<input type="text" name :placeholder="item.formdes" v-model="item.formval"
												@change="reNum(item.formval, $event)" class="telVal" @input="signIn"
												@blur="publicSignup.on_blur()" :disabled="forms.length == 1"
												:class="{ telDisabled: forms.length == 1 }" />
										</div>
										<!-- 邮箱 -->
										<div class="formItem" :key="index"
											v-if="item.formtype === 1 && item.formfix === 3">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<input type="text" name :placeholder="item.formdes" v-model="item.formval"
												class="telVal" @change="reEmail(item.formval, $event)"
												@blur="publicSignup.on_blur()" />
										</div>
										<!-- 身份证 -->
										<div class="formItem" :key="index"
											v-if="item.formtype === 1 && item.formfix === 4">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<input type="text" name :placeholder="item.formdes" v-model="item.formval"
												class="telVal" @change="reID(item.formval, $event)"
												@blur="publicSignup.on_blur()" />
										</div>
										<!-- 单选 -->
										<div class="formItem" :key="index"
											v-else-if="item.formtype === 2 && item.formfix === 0">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-radio-group v-model="item.formval">
												<van-radio :name="itemChild.value" icon-size="16"
													v-for="(itemChild, i) in item.formjsonval" :key="i">
													{{ itemChild.value }}
												</van-radio>
											</van-radio-group>
										</div>
										<!-- 性别 -->
										<div class="formItem" :key="index"
											v-else-if="item.formtype === 2 && item.formfix === 5">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-radio-group v-model="item.formval">
												<van-radio :name="itemChild.value" icon-size="16"
													v-for="(itemChild, i) in item.formjsonval" :key="i">
													{{ itemChild.value }}
												</van-radio>
											</van-radio-group>
										</div>
										<!-- 多选 -->
										<div class="formItem" :key="index" v-else-if="item.formtype === 3">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-checkbox-group v-model="item.formval">
												<van-checkbox :name="itemChild.value" shape="square" icon-size="16"
													v-for="(itemChild, i) in item.formjsonval" :key="i">
													{{ itemChild.text }}
												</van-checkbox>
											</van-checkbox-group>
										</div>
										<!-- 下拉框 -->
										<div class="formItem" :key="index" v-else-if="item.formtype === 4">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-icon name="arrow-down" color="#64748b" class="downIcon"
												size="1.39rem" />
											<select v-model="item.formval" @blur="publicSignup.on_blur()">
												<option v-for="(itemChild, i) in item.formjsonval" :key="i"
													:value="itemChild.value">{{ itemChild.text }}</option>
											</select>
										</div>
										<!-- 多行文本 -->
										<div class="formItem" :key="index" v-if="item.formtype === 5">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<textarea class="textarea" v-model="item.formval"></textarea>
										</div>
										<!-- 日期 -->
										<div class="formItem" :key="index" v-else-if="item.formtype === 9">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-cell is-link arrow-direction="down" @click="isShowPopup(item)">
												{{ item.formval }}
											</van-cell>
											<van-popup v-model="item.isShow" round position="bottom"
												:style="{ height: '50%' }" class="timePupop">
												<van-datetime-picker v-model="item.currentDate" type="date"
													@confirm="(date) => getTime(date, item)" @cancel="isShowPopup(item)"
													:min-date="minDate" />
											</van-popup>
										</div>
										<!-- 搜索下拉框 -->
										<div class="formItem" :key="index" v-if="item.formtype === 8">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-search :placeholder="item.formdes" v-model="item.formval"
												@focus="showSearchOption = true" @blur="blurs"
												@input="searchOptions(item)" />
											<div class="searchOption" v-show="showSearchOption">
												<ul class="searchOption-list" v-if="item.searchVal != false">
													<li class="searchOption-item"
														v-for="(itemChild, i) in item.searchVal" :key="i"
														@click.prevent="getSearchVal(itemChild.value, item)">
														{{ itemChild.value }}
													</li>
												</ul>
												<ul class="searchOption-list" v-else>
													<li class="searchOption-item"
														v-for="(itemChild, i) in item.formjsonval" :key="i"
														@click.prevent="getSearchVal(itemChild.value, item)">
														{{ itemChild.value }}
													</li>
												</ul>
											</div>
										</div>
										<!-- 省市区 -->
										<div class="formItem" :key="index" v-else-if="item.formtype === 6">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<van-cell is-link arrow-direction="down" @click="isShowPopup(item)">
												{{ item.cityVal }}
											</van-cell>
											<van-popup v-model="item.isShow" round position="bottom"
												:style="{ height: '50%' }" class="addressPupop">
												<van-area  :area-list="areaList"
													@confirm="(adress) => getAddress(adress, item)"
													@cancel="isShowPopup(item)" :columns-num="3" />
												<input type="hidden" :value="item.formval">
											</van-popup>
										</div>
										<!-- 分割线 -->
										<div class="divider" :key="index" v-else-if="item.formtype === 7">
											<div class="formItem-title">
												{{ item.formtitle }}
												<span v-show="item.isreq" class="mustfill">*</span>
											</div>
											<div class="dividerLine"></div>
										</div>
									</template>
								</form>
							</van-collapse-item>
						</van-collapse>
						<div class="agree" v-if="forms.length>0">
							<!-- <input type="checkbox" name="agree" v-model="protocol" /> -->
							<van-checkbox icon-size="14px" shape="square" v-model="protocol">同意</van-checkbox>
							<p><span @click="goProtocol">《用户协议》</span>和<span @click="goProtocol">《隐私政策》</span></p>
						</div>

					</div>
					<!-- <div class="homeBtn" v-if="meetingInfo.HomeUrl">
            <a :href="meetingInfo.HomeUrl">
              <van-icon name="wap-home-o" size="30px" color="#fff"
            /></a>
          </div> -->
				</div>
			</div>
		</div>
		<div class="registration-nextStep" ref="foot" v-if="!loading">
			<div class="reselect">
				<div class="reselect-content" @click="showPupop()" v-if="
		  flags.isTicketTypeList || ticketModalsDatas.is_multiuser
		">
					更改票种或人数
					<van-icon name="records" />
				</div>
			</div>
			<div class="nextStep" v-if="!loading">
				<div class="nextStep_container" v-if="flags.isTicketTypeList">
					合计：
					<span>
						¥
						<span class="total">{{
		                          Number(this.totalMoney).toFixed(2)
		                          }}</span>
					</span>
				</div>
				<div class="submitBtn nextBtn" :class="{ btnDisabled: surplusTicket === 0 && flags.isTicketTypeList }" @click="surplusTicket === 0 && flags.isTicketTypeList ? null : submit()" v-if="!showSubmitBtn">
					<span>提交信息/Submit</span>
				</div>
				<div class="submitBtn nextBtn" v-else>
					<van-loading size="20px" type="spinner" color="#fff">提交中/Submitting...</van-loading>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Loading from '@components/Loading.vue'
	import Area from '../../lib/area.js'
	import publicSignup from '../../lib/signUp.js'
	import wxShare from '../../lib/wxShare.js'
	import ChooseTicketModal from './components/chooseTicketModal'

	export default {
		neme: 'meetingsignup',
		components: {
			Loading,
			ChooseTicketModal,
		},
		data() {
			return {
				ticketModalsDatas: {
					ssl_count: '1'
				}, //弹框数据
				flags: {
					isTiketModalShow: false, //是否显示选择票种的弹框
					isTicketTypeList: false, //是否显示合计
				},
				meetingTitle: [],
				count: '1',
				bannerSrc: '',
				Area,
				forms: [], //多表单总数据
				activeNames: [0], // 手风琴默认展开第几个
				show: true,
				showSurplus: false, //余票
				title: '报名',
				selectTicket: '', //选中的票种
				selectPrice: '', //选中票种的金额
				numData: '1', //人数
				totalMoney: '', //总计金额
				showSearchOption: false,
				showfromTitle: true,
				signUpData: {
					signUp_Set: {},
				}, //接收的总数据
				ticketTypeDatas: {}, //票种id
				textareaVal: '', // 多行文本
				areaList: {}, //省市区
				addressData: [],
				searchVal: '', //搜索框的值
				currentDate: new Date(),
				params: {
					m: ''
				}, // code唯一标识
				showSubmitBtn: false, //提交中按钮
				settypeid: '',
				formdata: [], //表单数据
				minDate: new Date(1960, 0, 1), // 可选的最小日期
				publicSignup: {}, //通用js
				meetingInfo: {}, //会议基本信息
				is_check: false,
				is_multiuser: 0,
				win_h: document.body.scrollHeight,
				loading: false,
				regTel: true,
				regEmail: true,
				regID: true,
				regNumber: true,
				navShow: true,
				navhomeUrl: '',
				locationUrl: '',
				cityVal: '',
				fromPath: '',
				toSubmit: '',
				protocol: false,
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
				surplusTicket: '',
			}
		},
		watch: {
			count: {
				handler() {
					if (this.count == 1) {
						this.activeNames = [0]
					}
				},
			},
			win_h() {
				window.onresize = () => {
					if (document.body.scrollHeight < this.win_h) {
						this.$refs.foot.style.display = 'none'
					} else {
						this.$refs.foot.style.display = 'block'
					}
				}
			},
		},
		created() {
			const {
				m
			} = this.$route.query
			console.log(this.$route.query.toUrl)
			this.params.m = m
			this.areaList = Area
			this.init()
			this.publicSignup = new publicSignup()
			this.getMeetingInfo()
			this.toSubmit = localStorage.getItem('toSubmit')
			console.log(this.$route.query.code)

		},
		mounted() {
			window.addEventListener('resize', function() {
				if (document.activeElement.tagName === 'INPUT') {
					document.activeElement.scrollIntoView({
						behavior: 'smooth'
					})
				}
			})
		},

		computed: {
			meetId() {
				return this.$route.query.m
			},
		},
		methods: {
			async getMeetingInfo() {
				let opt = {
					m: this.params.m,
					ch: this.$route.query.ch,
				}
				this.meetingInfo = await this.publicSignup.init(opt, this)
				this.meetingTitle = this.meetingInfo.MeetingTitle.split('  ')
				this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
				this.footInfo.LogoLink = this.meetingInfo.LogoLink
				this.footInfo.LogoImg = this.meetingInfo.LogoImg
				//获取bnner图路径
				this.bannerSrc = this.meetingInfo.MobileBannerImage
				sessionStorage.setItem("isshowlogo", this.meetingInfo.isshowlogo)
				if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
					this.navShow = false
				} else {
					this.navShow = true
					this.navhomeUrl = this.meetingInfo.HomeUrl
				}
				//console.log(this.fromPath)
			},
			async init() {
				this.fetchInitSignConfig()
			},
			/**
			 * @description: 初始化报名配置接口
			 */
			async fetchInitSignConfig() {
				const _params = {
					m: this.meetId,
				}
				try {
					const ress = await this.$http.InitSignConfig(_params)

					if (ress.Code === 1000) {
						this.ticketModalsDatas = ress['signUp_Set']
						this.flags.isTicketTypeList = ress['signUp_Set'].SignUpSetType.length
						//当票种数据为空并且未开启多人报名时，弹框不显示
						let _ticket = this.ticketModalsDatas
						if (!_ticket.SignUpSetType.length && !_ticket.is_multiuser) {
							this.flags.isTiketModalShow = false
						} else {
							this.flags.isTiketModalShow = true
						}

						// -------------
						let res = this.deepCopy(ress)

						this.signUpData = this.deepCopy(ress)
						this.formdata = this.deepCopy(this.signUpData.form_Sets)
						if (res.signUp_Set.SignUpSetType) {
							this.ticketTypeDatas = res.signUp_Set.SignUpSetType
						}
						if (!res.signUp_Set.SignUpSetType && !this.is_multiuser) {
							this.isTiketModalShow = false
						} else {
							this.isTiketModalShow = true
						}
						this.setFormData()
					} else if (ress.Code === 7001) {
						this.$router.push({
							path: '/signup/signupinfo',
							query: this.$route.query,
						})
					} else if (ress.Code === 6004) {
						const {
							ch,
							channelId,
							red
						} = this.$route.query

						let is_check = ress.signUp_Set.is_check || 0
						let isSignPay = true
						if (ress.UserListEntity) {
							for (let i = 0; i < ress.UserListEntity.length; i++) {
								if (ress.UserListEntity[i].SignupStatusCode != 1) {
									isSignPay = false
								}
							}
						}

						let shouldJump = false
						if (is_check == 1) {
							// 开启了审核：找到当前用户，判断审核状态
							let currUser = ress.UserListEntity
								? ress.UserListEntity.find(u => u.muid == ress.keyid)
								: null
							if (currUser && currUser.userstatus == 1 && ress.signUp_Set.jump_link && isSignPay) {
								shouldJump = true
							}
						} else {
							// 未开启审核：保持原逻辑
							if (ress.signUp_Set.jump_link && isSignPay) {
								shouldJump = true
							}
						}

						let _link = red == 'no' ? '' : ress.signUp_Set.jump_link
						if (shouldJump && _link) {
							this.loading = true

							let _url = channelId !== undefined ? channelId : ch
							if (_link.indexOf('{channid}') !== -1) {
								_link = _link.replace('{channid}', _url)
							}

							if (_link.indexOf('userid') !== -1) {
								_link = _link.replace('{userid}', ress.keyid)
								window.location.href = _link
							} else {
								window.location.href = _link
							}
						} else {
							if (this.$route.query.toUrl) {
								if (this.$route.query.toUrl.indexOf('ScanCheckin') != -1) {
									this.$router.push({
										path: '/ScanCheckin',
										query: this.$route.query,
									})
								} else if (this.$route.query.toUrl.indexOf('hotelOrder') != -1) {
									this.$router.push({
										path: '/hotelList',
										query: {
											m: this.$route.query.m,
										}
									})
								}
							} else {
								this.$router.push({
									path: '/signup/signupinfo',
									query: this.$route.query,
								})
							}
						}
					}
					this.show = false
				} catch (error) {
					console.log(error)
				}
			},

			// ============
			async initShare(title, desc, link, imgUrl) {
				try {
					const headRes = await this.$http.csData({
						url: encodeURIComponent(
							window.location.href.replace(location.hash, '')
						),
					})
					const _Wx = new wxShare({
						opt: headRes,
					})
					_Wx.ready().then((wx) => {
						_Wx.share(title, desc, link, imgUrl)
						console.log(wx)
					})
				} catch (err) {
					console.log(err)
				}
			},
			// 深拷贝
			isObj(obj) {
				return (
					(typeof obj === 'object' || typeof obj === 'function') && obj !== null
				)
			},
			deepCopy(obj, hash = new WeakMap()) {
				if (hash.has(obj)) return hash.get(obj)
				let cloneObj = Array.isArray(obj) ? [] : {}
				hash.set(obj, cloneObj)
				for (let key in obj) {
					cloneObj[key] = this.isObj(obj[key]) ?
						this.deepCopy(obj[key], hash) :
						obj[key]
				}
				return cloneObj
			},

			getCheckedTicketIndex() {
				let selectPriceEl = document.querySelector('.ticketType_select .price')
				if (selectPriceEl) {
					this.selectPrice = selectPriceEl.innerHTML
					this.selectTicket = selectPriceEl.getAttribute('checkedTicket')
				}
			},
			// ---------------

			//二级数据
			subData(forms) {
				for (let j = 0; j < forms.length; j++) {
					forms[j].map((k, i) => {
						let _formtype = k.formtype
						if (
							_formtype === 2 ||
							_formtype === 4 ||
							_formtype === 8 ||
							_formtype === 3
						) {
							let _formjsonval
							if (typeof k.formjsonval == 'string') {
								_formjsonval = JSON.parse(k.formjsonval)
							} else {
								_formjsonval = k.formjsonval
							}
							if (_formtype === 3) {
								if (!this.forms[j][i].formval) {
									this.forms[j][i].formval = []
								}
							}
							this.forms[j][i].formjsonval = _formjsonval
							if (_formtype === 2) {
								//this.forms[j][i].formval = this.forms[j][i].formjsonval[0].value
								this.forms[j][i].formval = ''
							}
						} else if (_formtype === 9) {
							this.forms[j][i].currentDate = new Date()
						}
					})
				}
			},

			// 控制选择日期/地址弹出框的显示和隐藏
			isShowPopup(item) {
				item.isShow = !item.isShow
				setTimeout(() => {
					let set = document.querySelectorAll('button')
					for (let i = 0; i < set.length; i++) {
						set[i].setAttribute('type', 'button')
					}
				}, 0)
			},
			// 选择日期/选择地址 回调事件
			getTime(date, item) {
				let day = date.getDate()
				let month = date.getMonth() + 1
				let year = date.getFullYear()
				item.isShow = false
				item.formval = year + '-' + month + '-' + day
			},
			// 省市区

			getAddress(address, item) {
				let _address = []
				let _addressVal = []
				for (let i = 0; i < address.length; i++) {
					_address.push(address[i].code)
					_addressVal.push(address[i].name)
				}
				item.isShow = false
				item.formval = _addressVal.join(',')
				item.cityVal = _addressVal.join(',')
				console.log(item.formval, item.cityVal)
			},

			// 只能输入数字
			signIn() {
				for (let i = 0; i < this.forms.length; i++) {
					this.forms[i].map((k) => {
						if (k.formfix === 1) {
							if (k.formval) {
								k.formval = k.formval.replace(/[^\d]/g, '')
							}
						}
					})
				}
			},
			//搜索列表
			getSearchVal(val, item) {
				item.formval = val
				this.showSearchOption = false
			},
			blurs() {
				this.publicSignup.on_blur()
				setTimeout(() => {
					this.showSearchOption = false
				}, 0)
			},
			searchOptions(val) {
				if (val.formval) {
					for (let i = 0; i < val.formjsonval.length; i++) {
						let sd = val.formjsonval[i].value.indexOf(val.formval)
						if (sd != -1) {
							val.searchVal.push(val.formjsonval[i])
						}
					}
				} else {
					val.searchVal = []
				}
			},
			//正则匹配11位手机号
			reNum(val, ev) {
				this.regTel = this.publicSignup.regCheck(val, 'tel', ev, this)
			},
			reEmail(val, ev) {
				this.regEmail = this.publicSignup.regCheck(val, 'Email', ev, this)
			},
			reID(val, ev) {
				this.regID = this.publicSignup.regCheck(val, 'ID', ev, this)
			},
			reNumber(val, ev) {
				this.regNumber = this.publicSignup.regCheck(val, 'number', ev, this)
			},
			//提交表单
			submit() {
				if (this.surplusTicket !== '' ){
					console.log('surplusTicket1')
					if (!this.ticketModalsDatas.SignUpSetType.length && !this.ticketModalsDatas.is_multiuser) {
						
					}else{
						if( this.surplusTicket == 0 ){
							this.$notify({
								message: '该票种已售完！',
								type: 'danger',
							})
							return
						}
					}
				}		
				let _flag = true
				// 判断必填项是否为空
				for (let i = 0; i < this.forms.length; i++) {
					const children = this.forms[i]
					for (let j = 0; j < children.length; j++) {
						const item = children[j]
						if (item.formval == '请选择') {
							item.formval = ''
						}
						if (item.formfix == 6) {
							if (!this.regNumber) {
								this.$notify({
									message: '请输入正确的' + item.formtitle + '！',
									type: 'danger',
								})
								return
							}
						}
						if (item.isreq) {
							if (!item.formval) {
								const msg =
									this.forms.length > 1 ?
									'第' + (i + 1) + '位：' + item.formtitle :
									item.formtitle
								this.activeNames = [i]
								this.$notify({
									message: msg + '不能为空',
									type: 'danger',
								})
								return
							}
						}
					}
				}

				if (!this.regTel) {
					this.$notify({
						message: '请输入正确的手机号！',
						type: 'danger',
					})
					return
				}
				if (!this.regID) {
					this.$notify({
						message: '请输入正确的身份证号！',
						type: 'danger',
					})
					return
				}
				if (!this.regEmail) {
					this.$notify({
						message: '请输入正确的邮箱！',
						type: 'danger',
					})
					return
				}
				if (!this.protocol) {
					this.$notify({
						message: '请同意《用户协议》和《隐私政策》!',
						type: 'danger',
					})
					return
				}

				//获取表单数据
				let data = [],
					_datas = []
				let cloneForms = this.deepCopy(this.forms)
				//let cloneForms = this.forms
				// for (let s = 0; s < this.forms.length; s++) {
				//   for (let a = 0; a < this.forms[s].length; a++) {
				//     if (this.forms[s][a].formtype === 6) {
				//       cloneForms[s].push(this.forms[s][a])
				//     }
				//   }
				// }
				//console.log('forms', this.forms)
				//console.log('cloneForms', cloneForms)
				for (let j = 0; j < cloneForms.length; j++) {
					for (let i = 0; i < cloneForms[j].length; i++) {
						if (cloneForms[j][i].formtype === 7) {
							//cloneForms[j].pop(cloneForms[j][i])
							delete cloneForms[j][i]
						} else {
							if (cloneForms[j][i].formval === '请选择') {
								cloneForms[j][i].formval = ''
							}
							if (cloneForms[j][i].formtype === 3) {
								cloneForms[j][i].formval = String(cloneForms[j][i].formval)
							}

							data.push({
								value: cloneForms[j][i].formval,
								text: cloneForms[j][i].formtitle,
								formfix: cloneForms[j][i].formfix,
								formid: cloneForms[j][i].formid,
							})


						}
					}


					_datas.push(data)
					data = []


				}


				//console.log('提交的表单', _datas)

				let UserEntity = []
				for (let i = 0; i < _datas.length; i++) {
					UserEntity.push({
						DataEntity: _datas[i]
					})
				}

				let settypeid = this.settypeid || 0

				const {
					m,
					ch,
					channelId
				} = this.$route.query

				let datas = {
					m,
					settypeid: settypeid,
					chid: channelId !== undefined ? Number(channelId) : Number(ch),
					UserEntity,
				}

				//发送表单数据
				if (_flag) {
					this.showSubmitBtn = true
					console.log(datas)
					this.submitform(datas)
				}
			},
			goProtocol() {
				window.location.href = 'https://mp.weiqihd.com/msite/site/10351/11134'
			},
			async submitform(datas) {
				try {
					console.log(datas)
					let res = await this.$http.SubmitSignUp(datas)
					const _params = this.$route.query

					if (res.Code === 1000) {
						// if (
						//   this.ticketModalsDatas.jump_link &&
						//   this.$route.query.red != 'no'
						// ) {
						//   window.location.href = this.ticketModalsDatas.jump_link
						// } else {
						// if( this.fromPath == 'scanCheckin' || this.fromPath == 'hotelOrder'){
						//     this.$router.go(-1)
						// }else{
						//     this.$router.push({
						//         path: '/signup/signupinfo',
						//         query: _params,
						//     })
						// }  
						// }
						if (this.$route.query.toUrl) {
							if (this.$route.query.toUrl.indexOf('ScanCheckin') != -1) {
								this.$router.push({
									path: '/ScanCheckin',
									query: _params,
								})
							} else if (this.$route.query.toUrl.indexOf('hotelOrder') != -1) {
								this.$router.push({
									path: '/hotelList',
									query: {
										m: this.params.m,
									}
								})
							} else {
								this.$router.push({
									path: '/signup/signupinfo',
									query: _params,
								})
							}
						} else {
							this.$router.push({
								path: '/signup/signupinfo',
								query: _params,
							})
						}
					}
					this.showSubmitBtn = false
				} catch (err) {
					console.log(err)
				}
			},

			setFormData() {
				let _formdata = this.formdata.map((k) => {
					if (k.formval === null) {
						k.formval = ''
					}
					//给日期和省市增加控制显示隐藏属性
					if (k.formtype === 6) {
						k.formval = '请选择'
						k.isShow = false
						k.cityVal = ''
					}
					if (k.formtype === 8) {
						k.searchVal = []
					}
					if (k.formtype === 9) {
						var myDate = new Date();
						var year = myDate.getFullYear();
						var month = myDate.getMonth() + 1;
						var date = myDate.getDate();
						k.formval = '' + year + '-' + month + '-' + date + ''
						k.currentDate = new Date()
						k.isShow = false
						console.log(k)
					}
					return {
						...k,
					}
				})

				// var optionArr = []; 
				// _formdata.map((item, index) => { 
				//     var curDate = new Date()
				//     optionArr.push(
				//         Object.assign(item, { currentDate: curDate}) 
				//     )
				// });
				console.log(_formdata)
				this.forms.push(this.deepCopy(_formdata))
				this.subData(this.forms)
				for (let i = 0; i < this.forms.length; i++) {
					if (i > 0) {
						for (let j = 0; j < this.forms[i].length; j++) {
							if (
								this.forms[i][j].formtype === 1 &&
								this.forms[i][j].formfix === 1
							) {
								this.forms[i][j].formval = ''
							}
						}
					}
				}
				console.log(this.forms)
			},
			regCheck(val, type, event) {
				this.publicSignup.regCheck(val.formval, type, event, this)
			},
			handleGetTicketDatas(val) {
				console.log('valval',val)
				this.surplusTicket = val.surplusTicket
				this.flags.isTiketModalShow = false
				this.totalMoney = val.totalMoney
				this.settypeid = val.settypeid
				console.log(val, '-----')
				if (this.count < val.count) {
					let _count = val.count - this.count
					for (let i = 0; i < _count; i++) {
						this.setFormData()
					}
				} else if (this.count > val.count) {
					let _count = this.count - val.count
					for (let i = 0; i < _count; i++) {
						this.forms.pop()
					}
				}
				this.count = val.count
			},
			showPupop() {
				this.ticketModalsDatas.ssl_count = this.count
				this.flags.isTiketModalShow = true
			},
		},
		beforeRouteEnter(to, from, next) {
			next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
				console.log(from.name)
				vm.fromPath = from.name
			})
		},
	}
</script>
<style lang="scss">
	.van-picker__toolbar {
		height: 2.5rem !important;
	}

	.van-picker__cancel,
	.van-picker__confirm {
		font-size: 1.2rem !important;
		padding: 0 1rem !important;
	}

	.van-dialog {
		width: 60%;
		text-align: center;
		font-size: 32px;
		padding-top: 20px;

		.van-dialog__content {
			margin: 20px 0;
		}

		.van-button {
			font-size: 32px;
			line-height: 60px;
			height: 60px;
		}
	}

	input {
		-webkit-appearance: none;
		border: none;
		border-radius: none;
	}

	.van-field__clear {
		font-size: 1rem;
		right: 0.8rem !important;
	}

	#registration {
		.registration-container {
			.registration-content {
				#sl-collapse-item {
					margin-bottom: 30px;

					>div {
						padding: 0;

						&:first-child {
							padding: 0 10px;
						}

						>.van-cell__title {
							line-height: 80px;
							font-size: 32px;
							padding-left: 10px;
							color: #475569;
						}

						>.van-icon {
							line-height: 80px;
							font-size: 34px;
						}
					}
				}

				.registrationContent-form {
					.formItem {

						.van-checkbox__label,
						.van-radio__label {
							font-size: 26px;
							color: #475569;
						}

						.van-radio__label {
							line-height: 1.2rem !important;
						}

						.van-cell__value--alone {
							color: #475569;
						}

						.van-picker {
							.van-hairline--top-bottom {
								height: 3rem;

								>div {
									line-height: 3rem;
									padding: 0 0.625rem;
								}

								.van-picker__cancel,
								.van-picker__confirm {
									font-size: 30px;
								}
							}

							.van-picker__columns {
								.van-picker-column {
									font-size: 1rem;
								}
							}
						}

						.van-search {
							padding: 0;

							.van-search__content {
								padding: 0;
								background-color: #fff;
							}
						}

						.van-cell {
							height: 2.4rem;
							font-size: 0.875rem;
							padding: 0.8rem 0 0 0.625rem;

							.van-field__left-icon {
								.van-icon {
									font-size: 1.2rem;
								}
							}
						}

						.textarea {
							padding: 20px 0px;
							padding-left: 0.625rem;
							min-height: 2.4rem;
							width: 100%;
							font-size: 0.875rem;
							color: #1e293b;
							line-height: 40px;
							border: 1px solid #e2e8f0;
						}
					}
				}
			}
		}

		.submitBtn {
			.van-loading__text {
				font-size: 30px;
				color: #fff;
			}
		}
	}

	.signup_desc {
		margin: 1rem auto;
		padding: 0 20px;

		b {
			font-weight: bold;
		}
	}
.btnDisabled {
		opacity: 0.5;
		pointer-events: none;
	}
</style>
<style lang="scss" scoped>
	.nav {
		height: 76px;
		font-size: 26px;
		line-height: 76px;
		background: #3b82f6 url(../../assets/home.png) no-repeat 20px center;
		background-size: 30px 30px;
		color: #fff;
		padding: 0 30px 0 60px;

		a {
			color: #fff;
		}
	}

	.telDisabled {
		background: #f1f5f9;
	}

	.disNone {
		display: none;
	}

	.ticketType_select {
		border: 2px solid #3b82f6;

		&::after {
			content: '';
			position: absolute;
			bottom: 0;
			right: 0;
			border-bottom: 30px solid #3b82f6;
			border-left: 30px solid transparent;
			border-top: 30px solid transparent;
		}
	}

	.nextStep {
		display: flex;
		height: 96px;
		line-height: 108px;
		margin-top: 60px;
		font-size: 28px;

		.nextStep_container {
			border-top: 2px solid #e2e8f0;
			flex: 1;
			padding-left: 4%;

			>span {
				font-size: 32px;
				color: #e6a23c;
			}
		}

		.nextBtn {
			flex: 1;
			height: 96px;
			line-height: 96px;
			text-align: center;
			background: #3b82f6;
			color: #fff;
			font-size: 36px;
		}
	}

	// ------------
	#registration {
		width: 100%;

		.registration-container {
			padding-bottom: 80px;

			#num_popup {
				position: fixed;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				background: rgba(0, 0, 0, 0.76);
				z-index: 2;

				.num_popup_container {
					width: 92%;
					position: absolute;
					top: 46%;
					left: 50%;
					transform: translate(-50%, -50%);
					box-shadow: 0 0 4px rgba(0,0,0,0.08);
					border-radius: 12px;
					padding-top: 20px;
					font-size: 28px;
					background: #fff;
					margin: 0 auto;
					max-height: 80%;
					overflow: auto;

					.ticketType {
						width: 92%;
						margin: 0 auto;
						margin-bottom: 60px;

						.ticketType_title {
							font-size: 28px;
							height: 80px;
							line-height: 80px;
						}

						.ticketType_item {
							width: 100%;

							font-size: 28px;
							margin-bottom: 20px;

							.ticketType_item_main {
								line-height: 90px;
								box-sizing: border-box;
								padding: 0 3%;
								background: #ffffff;
								box-shadow: 0 2px 12px rgba(0,0,0,0.04);
								border-radius: 12px;
								position: relative;
							}

							.ticketType_item_container {
								height: 90px;
								display: flex;
								justify-content: space-between;

								.price_container {
									font-size: 32px;
									color: #e6a23c;
								}

								.prohibit {
									color: #94a3b8;
								}
							}

							.ticketTypeTips {
								height: 40px;
								line-height: 50px;
								font-size: 26px;
								color: #e6a23c;
							}
						}
					}

					#select_number {
						width: 92%;
						margin: 0 auto;

						.select_number_container {
							.select_number_title {
								font-size: 28px;
								height: 60px;
								line-height: 60px;
							}

							.select_number_content {
								height: 100px;
								line-height: 100px;
								color: #64748b;
								display: flex;
								align-items: center;
								align-content: center;

								.reduce,
								.increase {
									width: 66px;
									height: 60px;
									line-height: 40px;
									background: #f1f5f9;
									font-size: 60px;
									text-align: center;
									position: relative;

									>img {
										width: 70%;
										position: absolute;
										top: 50%;
										left: 50%;
										transform: translate(-50%, -50%);
									}
								}

								.reduce {
									>img {
										width: 50%;
									}
								}

								.num {
									height: 56px;
									width: 66px;
									text-align: center;
									line-height: 62px;
									font-size: 28px;
									background: #fff;
									border-radius: 0;
									box-shadow: 0 1px 4px rgba(0,0,0,0.06);
									margin: 0 4px;
									color: #1e293b;

									&::placeholder {
										font-size: 62px;
									}
								}

								.remainingTickets {
									display: inline-block;
									margin-left: 4%;
								}
							}
						}
					}
				}
			}

			.registration-banner {
				>img {
					width: 100%;
				}
			}

			.registration-content {
				width: 98%;
				margin: 0 auto;
				font-size: 0.875rem;
				font-weight: 300;

				.registrationContent-title {
					text-align: center;
					width: 100%;
					margin: 1rem auto;
					padding-bottom: 16px;
					border-bottom: 1px solid #3b82f6;
					word-break: break-word;
					>div {
						font-size: 1.25rem;
						font-weight: 600;
						padding-bottom: 0.375rem;
						color: #1e293b;
					}
				}

				.registrationContent-form {
					.formItem {
						padding: 0.625rem;
						margin-bottom: 0.8rem;
						box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 1px solid #e2e8f0;
						position: relative;
						background-color: #fff;

						.formItem-title {
							margin-bottom: 0.625rem;
							font-size: 28px;
							font-weight: 400;
							color: #1e293b;
						}

						>input[type='text'] {
							width: 100%;
							height: 2.4rem;
							font-size: 28px;
							color: #1e293b;
							box-sizing: border-box;
							border: 1px solid #e2e8f0;
							padding: 0 0.625rem;
							box-shadow: none;
							border-radius: 8px;

							&::-webkit-input-placeholder {
								font-size: 26px;
							}

							&:focus {
								border: 1px solid #3b82f6;
							}
						}

						.van-radio,
						.van-checkbox {
							min-height: 2rem;
							//line-height: 2rem !important;
						}

						select {
							height: 2.2rem;
							width: 100%;
							border: 1px solid #e2e8f0;
							-webkit-appearance: none;
							padding-left: 0.625rem;
							font-size: 30px;
							background: url() no-repeat right;
							background-size: 2rem;
							border-radius: 8px;
							color: #475569;
						}

						.van-cell {
							height: 2.2rem;
							font-size: 0.875rem;
							padding: 0.625rem 0.625rem 0 0.625rem;
							border: 1px solid #e2e8f0;
							font-weight: normal;
							line-height: 1rem;
							border-radius: 8px;
						}

						.van-icon {
							font-size: 1.375rem;
						}

						.downIcon {
							position: absolute;
							bottom: 0.98rem;
							right: 1.25rem;
						}

						.searchOption {
							width: 100%;
							border-radius: 8px;
							border: 1px solid #e2e8f0;
							padding: 0.4rem;
							padding-bottom: 0.6rem;
							box-sizing: border-box;
							margin-top: 0.8rem;
							transition: all 2s;
							z-index: 2;

							.searchOption-list {
								.searchOption-item {
									height: 2rem;
									border-bottom: 1px solid #e2e8f0;
									line-height: 2rem;
									font-size: 28px;
								}
							}
						}

						.mustfill {
							color: #f56c6c;
							margin-left: 0.3rem;
						}
					}

					.divider {
						font-size: 24px;

						.dividerLine {
							margin: 20px 0px;
							border-top: 1px solid #e2e8f0;
						}
					}
				}


			}

			.homeBtn {
				position: fixed;
				right: 8px;
				bottom: 160px;

				i {
					width: 80px;
					height: 80px;
					background: #3b82f6;
					text-align: center;
					border-radius: 2rem;

					&::before {
						margin-top: 8px;
					}
				}
			}
		}

		.registration-nextStep {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			background: #ffffff;
			z-index: 1;

			.reselect {
				margin-top: 10px;
				margin-bottom: 20px;
				margin-left: 20px;
				color: #3b82f6;
				font-size: 28px;

				.reselect-content {
					display: flex;

					.van-icon {
						font-size: 36px;
					}
				}
			}

			.nextStep {
				margin-top: 10px;
			}
		}
	}

	.agree {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-top: 30px;
		font-size: 26px;
		color: #475569;
		padding: 0 40px;

		label {
			display: flex;
			align-items: center;
		}

		input {
			margin-right: 10px;
			width: 28px;
			height: 28px;
			-webkit-appearance: auto;
			border: auto;
		}

		p {
			span {
				color: #3b82f6;
			}
		}
	}
.btnDisabled {
		opacity: 0.5;
		pointer-events: none;
	}
</style>
